import type { DetailedHTMLProps, InputHTMLAttributes, RefObject } from 'react';
import { useRef } from 'react';

import { IconSystemButton } from '#components/base/IconButton/IconSystemButton';

import styles from './LocationInput.module.scss';

type Props = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & { ref?: RefObject<HTMLInputElement | null> };

// eslint-disable-next-line func-style
export const LocationInput = ({ ref, className, onFocus, onBlur, ...inputProps }: Props) => {
	const localRef = useRef<HTMLInputElement | null>(undefined);

	return (
		<div className={styles.inputWrapper}>
			<input
				className={`${styles.input} ${className ?? ''}`}
				ref={(r) => {
					localRef.current = r;
					if (typeof ref === 'function') {
						ref(r);
					} else if (ref) {
						ref.current = r;
					}
				}}
				onFocus={(e) => {
					// select the text in the input field
					localRef?.current?.select();
					onFocus?.(e);
				}}
				onBlur={(e) => {
					// deselect the text in the input field
					localRef?.current?.setSelectionRange(localRef.current.value.length, localRef.current.value.length);
					onBlur?.(e);
				}}
				{...inputProps}
				// set the size of the text input to account for the value
				// if the browser supports field-sizing this will have no effect
				// do not remove as browser support is not high right now https://caniuse.com/mdn-css_properties_field-sizing
				size={inputProps.value?.toString().length}
			/>

			<IconSystemButton
				type="tertiary"
				size="s"
				icon="edit"
				variant="filled"
				title="Bearbeiten"
				className={styles.editIcon}
				onClick={() => {
					localRef?.current?.focus();
				}}
				onFocus={() => {
					// delegate focus to text field
					localRef?.current?.focus();
				}}
			/>
		</div>
	);
};
